/* Rough Old Glass – estimator sense checks (Oct 2026)
   - Flags sizes that look like a unit mix-up (e.g. 200 x 200 mm when 2000 x 2000 mm was meant)
     and offers one-tap fixes.
   - Framed mirror calculator: when Frameless is chosen, and again if Frameless + no fixings,
     points people who just want wall-fixed panels to the Panels & Splashbacks calculator. */
(function () {
  var PANELS_URL = '/pages/bespoke-tiles';
  var LOW_MM = 300;     /* anything under 30 cm is almost always a typo for these products */
  var HIGH_MM = 4000;   /* over 4 m on one side usually means mm typed into a cm/inch box */

  function toMm(v, unit) {
    if (unit === 'cm') return v * 10;
    if (unit === 'inch') return v * 25.4;
    return v;
  }
  function unitLabel(u) { return u === 'cm' ? 'cm' : (u === 'inch' ? 'inches' : 'mm'); }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }

  function makeNote(cls) {
    var d = document.createElement('div');
    d.className = 'rog-note ' + (cls || '');
    d.setAttribute('role', 'status');
    return d;
  }

  /* Build the message and fix buttons for one width/height pair */
  function assess(w, h, unit) {
    var vals = [w, h].filter(function (x) { return x > 0; });
    if (!vals.length) return null;
    var mm = vals.map(function (x) { return toMm(x, unit); });
    var small = mm.some(function (x) { return x < LOW_MM; });
    var big = mm.some(function (x) { return x > HIGH_MM; });
    if (!small && !big) return null;
    var shown = vals.map(fmt).join(' × ') + ' ' + unitLabel(unit);
    /* Say the size back in a second unit so the mistake is obvious */
    var totalMm = unit === 'mm'
      ? mm.map(function (x) { return fmt(x / 10); }).join(' × ') + ' cm'
      : mm.map(function (x) { return Math.round(x); }).join(' × ') + ' mm';
    if (small) {
      var fixes = [];
      if (unit === 'mm') {
        fixes.push({ label: 'Make it ' + vals.map(function (x) { return fmt(x * 10); }).join(' × ') + ' mm', mult: 10 });
        fixes.push({ label: 'I meant ' + shown.replace(' mm', ' cm') , unit: 'cm' });
      } else if (unit === 'cm') {
        fixes.push({ label: 'Make it ' + vals.map(function (x) { return fmt(x * 10); }).join(' × ') + ' cm', mult: 10 });
      }
      return {
        text: 'You’ve entered ' + shown + ', which is only ' + totalMm + '. Most of our panels and mirrors are much larger, so please check the unit and the numbers.',
        fixes: fixes
      };
    }
    var fixesBig = [];
    if (unit !== 'mm') fixesBig.push({ label: 'These are millimetres', unit: 'mm' });
    return {
      text: 'You’ve entered ' + shown + ' (' + totalMm + '). That is larger than we usually make in one piece. If you measured in millimetres, change the unit to mm; for very large walls we’ll split it into panels and confirm the layout with you.',
      fixes: fixesBig
    };
  }

  function renderNote(note, result, applyFix) {
    if (!result) { note.hidden = true; note.innerHTML = ''; return; }
    note.hidden = false;
    note.innerHTML = '';
    var p = document.createElement('p'); p.textContent = result.text; note.appendChild(p);
    if (result.fixes.length) {
      var row = document.createElement('div'); row.className = 'rog-note-actions';
      result.fixes.forEach(function (f) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'rog-btn'; b.textContent = f.label;
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); applyFix(f); });
        row.appendChild(b);
      });
      var ok = document.createElement('button'); ok.type = 'button'; ok.className = 'rog-btn rog-btn-quiet'; ok.textContent = 'The size is correct';
      ok.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); note.hidden = true; note.dataset.ok = '1'; });
      row.appendChild(ok);
      note.appendChild(row);
    }
    var help = document.createElement('p'); help.className = 'rog-note-help';
    help.innerHTML = 'Not sure how to measure? Call us on <a href="tel:+443455488586">0345 548 8586</a> and we’ll help.';
    note.appendChild(help);
  }

  /* ---------- Panels & Splashbacks calculator (Vue) ---------- */
  function panelsState() {
    var w = document.querySelector('.customiser--wrapper');
    var vm = w && w.__vue__;
    return vm && vm.$root && vm.$root.$store ? vm.$root.$store.state : null;
  }
  function panelsUnit() {
    var s = panelsState();
    var t = (s && s.unitOfMeasurement) ? String(s.unitOfMeasurement).toLowerCase() : '';
    if (!t) { var v = document.querySelector('.tiles-customiser .step--dropdown.unit .value'); t = v ? v.textContent.trim().toLowerCase() : ''; }
    if (t.indexOf('centi') === 0 || t === 'cm') return 'cm';
    if (t.indexOf('inch') === 0) return 'inch';
    return 'mm';
  }
  function setVueInput(input, val) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, String(val));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function choosePanelsUnit(u) {
    var want = u === 'cm' ? ['centi', 'cm'] : (u === 'inch' ? ['inch'] : ['milli', 'mm']);
    var items = document.querySelectorAll('.tiles-customiser .step--dropdown.unit li');
    for (var i = 0; i < items.length; i++) {
      var t = items[i].textContent.trim().toLowerCase();
      if (want.some(function (w) { return t.indexOf(w) === 0; })) { items[i].click(); return; }
    }
  }
  function checkTile(tile) {
    var wI = tile.querySelector('.input-styled.width input');
    var hI = tile.querySelector('.input-styled.height input');
    if (!wI || !hI) return;
    var note = tile.querySelector('.rog-note');
    if (!note) { note = makeNote('rog-note-tile'); tile.appendChild(note); }
    var w = parseFloat(wI.value), h = parseFloat(hI.value);
    var key = [w, h, panelsUnit()].join('|');
    if (note.dataset.ok === '1' && note.dataset.key === key) return;
    note.dataset.ok = ''; note.dataset.key = key;
    renderNote(note, assess(w, h, panelsUnit()), function (f) {
      if (f.mult) {
        if (w > 0) setVueInput(wI, Math.round(w * f.mult * 10) / 10);
        if (h > 0) setVueInput(hI, Math.round(h * f.mult * 10) / 10);
      }
      if (f.unit) choosePanelsUnit(f.unit);
      setTimeout(function () { checkTile(tile); }, 50);
    });
  }
  function initPanels() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.tiles-customiser .tile .input-styled input')) checkTile(t.closest('.tile'));
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.tiles-customiser .step--dropdown.unit li')) {
        setTimeout(function () {
          document.querySelectorAll('.tiles-customiser .tile').forEach(checkTile);
        }, 60);
      }
    }, true);
  }


  /* ---------- Panels calculator: clearer wording and drawing checks (Oct 2026) ---------- */
  /* Labels are display-only: the calculator stores its choices separately, so renaming is safe. */
  var LABELS = [
    ['Add Panels', 'Add more panels'],
    ['No Drawings or Templates Required', 'Not needed (no cut-outs or holes)'],
    ['I will provide a sketched drawing', 'I’ll provide a sketch (one per wall)'],
    ['I will provide a DXF (CAD) drawing', 'I’ll provide a DXF (CAD) drawing'],
    ['I will provide an MDF or Ply Template', 'I’ll provide an MDF or ply template'],
    ['Float (Not suitable for use behind a heat source or with cutouts)', 'Float (non-toughened glass) – not suitable behind a heat source or with cut-outs']
  ];
  var UNITS = { 'Centimeter': 'cm', 'Centimeters': 'cm', 'Millimeters': 'mm', 'Millimeter': 'mm', 'Inches': 'inch', 'Inch': 'inch' };
  var DRAWING_INTRO = '<strong>No drawing is needed</strong> for squares, rectangles, circles, true ovals and arched tops, unless they have cut-outs or holes.<br>' +
    '<strong>Inverted T, raked, scribed and free-shape panels</strong>, and any panel with cut-outs or holes (for sockets, switches, pipes or to fit around cabinetry), need a sketch, DXF drawing or template.';
  var SIZE_HINT = 'Enter the size of <strong>each individual panel</strong>, not the whole wall. For several panels the same size, enter one size and the quantity.';
  var NONE_LABEL = 'No Drawings or Templates Required';

  function relabelPanels(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      var v = t.nodeValue, nv = v;
      if (!v || !v.trim()) return;
      LABELS.forEach(function (l) { if (nv.indexOf(l[0]) > -1) nv = nv.split(l[0]).join(l[1]); });
      var tr = nv.trim();
      if (UNITS[tr] && t.parentElement && t.parentElement.closest('.step--dropdown.unit')) nv = nv.replace(tr, UNITS[tr]);
      if (nv !== v) t.nodeValue = nv;
    });
  }

  function needsDrawing(s) {
    var why = [];
    (s.tilesDimensions || []).forEach(function (t) {
      var x = t && t.shape && shapeBy(t.shape.option);
      if (x && x[2] !== 'geo') { var n = x[0].replace(' Shape', '').toLowerCase(); if (why.indexOf(n) < 0) why.push(n); }
    });
    var q = function (arr) { return (arr || []).reduce(function (a, x) { return a + (parseFloat(x && x.quantity) || 0); }, 0); };
    if (q(s.cutOuts) > 0) why.push('cutouts');
    if (q(s.holes) > 0) why.push('holes');
    return why;
  }
  function whyText(why) {
    var m = { cutouts: 'cut-outs', holes: 'holes' };
    var parts = why.map(function (k) { return m[k] || ('a ' + k + ' panel'); });
    return parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
  }
  function drawingItems() { return document.querySelectorAll('.tiles-customiser .drawings--dropdown li'); }
  function goToDrawings(pick) {
    /* Step 3 is Size & Shape, where the drawings question lives */
    if (!document.querySelector('.tiles-customiser .drawings--dropdown')) location.hash = '#/3';
    var tries = 0;
    (function wait() {
      var dd = document.querySelector('.tiles-customiser .drawings--dropdown');
      if (!dd) { if (tries++ < 20) setTimeout(wait, 100); return; }
      if (pick != null && drawingItems()[pick]) drawingItems()[pick].click();
      dd.scrollIntoView({ block: 'center', behavior: 'smooth' });
      dd.classList.add('rog-note-flash');
      setTimeout(function () { dd.classList.remove('rog-note-flash'); }, 1600);
    })();
  }
  function noteEl(id, cls, where, before) {
    var n = document.getElementById(id);
    if (!where) { if (n) n.hidden = true; return null; }
    if (!n || !where.contains(n)) {
      if (n) n.remove();
      n = makeNote(cls); n.id = id;
      if (before) where.insertBefore(n, before); else where.appendChild(n);
    }
    return n;
  }
  function setNote(n, html, buttons) {
    if (!n) return;
    var key = html + '|' + buttons.map(function (b) { return b[0]; }).join('|');
    n.hidden = false;
    if (n.dataset.key === key) return;
    n.dataset.key = key;
    n.innerHTML = '<p>' + html + '</p>' + (buttons.length ? '<div class="rog-note-actions"></div>' : '');
    var bar = n.querySelector('.rog-note-actions');
    buttons.forEach(function (b, i) {
      var el = document.createElement('button'); el.type = 'button';
      el.className = 'rog-btn' + (i ? ' rog-btn-quiet' : ''); el.textContent = b[0];
      el.addEventListener('click', b[1]); bar.appendChild(el);
    });
  }

  function panelsUX() {
    var app = document.querySelector('.tiles-customiser');
    if (!app) return;
    relabelPanels(app);
    var s = panelsState();

    /* Drawings intro and size hint (size & shape step) */
    var dIntro = document.querySelector('.tiles-customiser .grid.drawings > p.step-font');
    if (dIntro && !dIntro.dataset.rog) { dIntro.dataset.rog = '1'; dIntro.innerHTML = DRAWING_INTRO; }
    var ua = document.querySelector('.tiles-customiser .tiles-header .unit-area');
    if (ua && !document.querySelector('.tiles-customiser .rog-size-hint')) {
      var h = document.createElement('p'); h.className = 'rog-size-hint'; h.innerHTML = SIZE_HINT;
      ua.parentNode.insertBefore(h, ua.nextSibling);
    }
    document.querySelectorAll('.tiles-customiser .tile .step--dropdown').forEach(function (d) {
      var l = d.querySelector('.label');
      if (l && /shape/i.test(l.textContent)) d.classList.add('rog-emph');
    });
    var dd = document.querySelector('.tiles-customiser .drawings--dropdown');
    if (dd) dd.classList.add('rog-emph');
    if (!s) return;

    var why = needsDrawing(s);
    var opt = s.drawingOption || '';
    var none = opt === NONE_LABEL;
    var chosen = opt && !none;
    var cont = document.querySelector('.tiles-customiser .right-column .step--container');
    var onSize = cont && cont.classList.contains('size--and--shape');
    var later = cont && !onSize && !cont.classList.contains('your--details') && !cont.classList.contains('glass--finish');

    /* On the size step: react straight away to the shape choice */
    var drawBox = document.querySelector('.tiles-customiser .grid.drawings');
    var n1 = noteEl('rog-draw-note', '', null); /* replaced by the shape rules (rog-draw-rule) */
    if (n1) {
      if (none && why.length) {
        setNote(n1, '<strong>This needs a drawing.</strong> You’ve chosen ' + whyText(why) + ', so we’ll need a sketch, DXF drawing or template to make it accurately.',
          [['I’ll provide a sketch', function () { drawingItems()[1] && drawingItems()[1].click(); }]]);
      } else n1.hidden = true;
    }

    /* Later steps and the price summary: catch a mismatch before they finish */
    var n2 = noteEl('rog-draw-check', '', later ? cont : null, later ? cont.firstChild : null);
    if (n2) {
      if (none && why.length) {
        setNote(n2, '<strong>A drawing is needed.</strong> You’ve added ' + whyText(why) + ' but chose “no drawing”. Please choose a sketch, DXF drawing or template so we can make the panels to fit.',
          [['Choose a drawing option', function () { goToDrawings(null); }]]);
      } else if (chosen && !why.length && cont.classList.contains('summary')) {
        var cost = s.drawing && Number(s.drawing.drawingSurcharge) > 0 ? ' and save the £' + Number(s.drawing.drawingSurcharge).toFixed(0) + ' drawing charge' : '';
        n2.classList.add('rog-note-info');
        setNote(n2, '<strong>You may not need a drawing.</strong> All your panels are square or rectangular with no cut-outs or holes, so we can work from the sizes you’ve entered. You can remove the drawing' + cost + '.',
          [['Remove the drawing', function () { goToDrawings(0); }], ['Keep it', function () { n2.dataset.dismissed = '1'; n2.hidden = true; }]]);
        if (n2.dataset.dismissed) n2.hidden = true;
      } else n2.hidden = true;
    }
  }
  function initPanelsUX() {
    var pending = false;
    try {
      new MutationObserver(function () {
        if (pending) return; pending = true;
        setTimeout(function () { pending = false; try { panelsUX(); } catch (e) {} }, 120);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    document.addEventListener('click', function () { setTimeout(function () { try { panelsUX(); } catch (e) {} }, 150); }, true);
    try { panelsUX(); } catch (e) {}
  }

  /* ---------- Framed mirror calculator (jQuery) ---------- */
  function framedUnit() {
    var v = document.querySelector('#unit .value');
    var t = v ? v.textContent.trim().toLowerCase() : 'mm';
    return t === 'cm' ? 'cm' : (t === 'inch' ? 'inch' : 'mm');
  }
  function setFramedInput(id, val) {
    var $ = window.jQuery;
    var box = document.getElementById(id);
    var input = box && box.querySelector('input');
    if (!input) return;
    input.value = String(val);
    if ($) $(input).trigger('change'); else input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function chooseFramedUnit(u) {
    var items = document.querySelectorAll('#unit li');
    for (var i = 0; i < items.length; i++) {
      if (items[i].textContent.trim().toLowerCase() === u) { items[i].click(); return; }
    }
  }
  function checkFramedSize() {
    var wBox = document.getElementById('width'), hBox = document.getElementById('height');
    if (!wBox || !hBox) return;
    var anchor = hBox.parentElement;
    var note = document.getElementById('rog-size-note');
    if (!note) { note = makeNote(); note.id = 'rog-size-note'; anchor.parentElement.insertBefore(note, anchor.nextSibling); }
    var w = parseFloat(wBox.querySelector('input').value), h = parseFloat(hBox.querySelector('input').value);
    var key = [w, h, framedUnit()].join('|');
    if (note.dataset.ok === '1' && note.dataset.key === key) return;
    note.dataset.ok = ''; note.dataset.key = key;
    renderNote(note, assess(w, h, framedUnit()), function (f) {
      if (f.mult) {
        if (w > 0) setFramedInput('width', Math.round(w * f.mult * 10) / 10);
        if (h > 0) setFramedInput('height', Math.round(h * f.mult * 10) / 10);
      }
      if (f.unit) chooseFramedUnit(f.unit);
      setTimeout(checkFramedSize, 50);
    });
  }

  function framelessNote() {
    var grid = document.querySelector('#finish .grid');
    if (!grid) return null;
    var n = document.getElementById('rog-frameless-note');
    if (!n) {
      n = makeNote('rog-note-info'); n.id = 'rog-frameless-note';
      n.innerHTML = '<p><strong>Frameless here means a ready-to-hang mirror</strong> on a backing board with hanging fixings.</p>' +
        '<p>If you just need antique mirror panels to fix straight onto a wall, splashback or furniture, the <a href="' + PANELS_URL + '">Panels &amp; Splashbacks calculator</a> is the right one and will price it correctly.</p>';
      n.hidden = true;
      grid.parentElement.appendChild(n);
    }
    return n;
  }
  function selectedFrameless() {
    var t = document.querySelector('#finish .frame-element.selected .bottom .title');
    return !!t && t.textContent.trim() === 'Frameless';
  }
  function fixingsNo() {
    var v = document.querySelector('#fixings .value');
    return !!v && v.textContent.trim().toLowerCase() === 'no';
  }
  function fixingsNote() {
    var box = document.getElementById('fixings');
    if (!box) return null;
    var n = document.getElementById('rog-fixings-note');
    if (!n) {
      n = makeNote('rog-note-info'); n.id = 'rog-fixings-note'; n.hidden = true;
      n.innerHTML = '<p><strong>Frameless with no fixings?</strong> That is usually a mirror panel to be fixed to a wall or into joinery rather than a hanging mirror.</p>' +
        '<p>The <a href="' + PANELS_URL + '">Panels &amp; Splashbacks calculator</a> covers glass-only panels, cut-outs, edges and adhesive. If you do want a frameless hanging mirror, carry on here.</p>';
      box.parentElement.appendChild(n);
    }
    return n;
  }
  function refreshFramedHints() {
    var f = framelessNote(); if (f) f.hidden = !selectedFrameless();
    var x = fixingsNote(); if (x) x.hidden = !(selectedFrameless() && fixingsNo());
  }

  function initFramed() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('#width, #height')) checkFramedSize();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#unit li')) setTimeout(checkFramedSize, 60);
      if (t.closest('#finish .frame-element') || t.closest('#fixings li')) setTimeout(refreshFramedHints, 60);
      if (t.closest('#orientation .orientation')) { var on = document.getElementById('rog-orient-note'); if (on) on.hidden = true; }
    }, true);
    /* Last check before leaving the size step: make the warning impossible to miss */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.total-submit .next, .mobile-header .next')) return;
      var step = document.querySelector('.step:not(.hideStep)');
      if (!step || step.getAttribute('name') !== 'sizeSection') return;
      checkFramedSize();
      /* An orientation must be chosen before moving on (the calculator itself doesn't insist) */
      var oSec = document.getElementById('orientation');
      if (oSec && !oSec.querySelector('.orientation.selected')) {
        e.preventDefault(); e.stopImmediatePropagation();
        var on = document.getElementById('rog-orient-note');
        if (!on) { on = makeNote(); on.id = 'rog-orient-note'; on.innerHTML = '<p><strong>Please choose how you’d like to hang your mirror:</strong> portrait, landscape, or the ability to hang it either way.</p>'; oSec.appendChild(on); }
        on.hidden = false;
        on.classList.add('rog-note-flash');
        oSec.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { on.classList.remove('rog-note-flash'); }, 1600);
        return;
      }
      var note = document.getElementById('rog-size-note');
      if (note && !note.hidden && note.dataset.ok !== '1' && !note.dataset.nudged) {
        note.dataset.nudged = '1';
        e.preventDefault(); e.stopImmediatePropagation();
        note.classList.add('rog-note-flash');
        note.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { note.classList.remove('rog-note-flash'); }, 1600);
      }
    }, true);
  }

  /* Same wording on both calculators' first button. The panels button lives in
     the bundled app, so keep re-applying it if the app re-renders. */
  var START_LABEL = 'Start your estimate';
  function relabel() {
    var b = document.getElementById('form-BespokeTiles-YourDetails_button-submit');
    if (b && b.value !== START_LABEL) b.value = START_LABEL;
  }
  function initLabel() {
    relabel();
    try {
      new MutationObserver(relabel).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* ---------- Units on the same line as the measurements (12 Oct 2026) ----------
     People were missing the unit box above the panels and typing cm into mm (or the
     other way round). Now each width/height box shows its unit inside it, the panels
     calculator has a mm / cm / inch switch on every panel row, and a plain-English
     line under the sizes says what the numbers mean (e.g. "90 × 60 cm, 0.9 × 0.6 m"). */
  function short(u) { return u === 'inch' ? 'in' : u; }
  function readoutText(w, h, unit, what) {
    var vals = [w, h].filter(function (x) { return x > 0; });
    if (vals.length < 2) return '';
    var mm = vals.map(function (x) { return toMm(x, unit); });
    var cm = mm.map(function (x) { return fmt(x / 10); }).join(' × ') + ' cm';
    var m = mm.map(function (x) { return (Math.round(x / 10) / 100).toString(); }).join(' × ') + ' m';
    var mmTxt = mm.map(function (x) { return Math.round(x); }).join(' × ') + ' mm';
    var also = unit === 'mm' ? cm + ' (' + m + ')' : (unit === 'cm' ? mmTxt + ' (' + m + ')' : mmTxt + ' (' + cm + ')');
    return what + vals.map(fmt).join(' × ') + ' ' + unitLabel(unit) + ' wide × high = <strong>' + also + '</strong>';
  }
  function suffix(box, unit) {
    if (!box) return;
    var s = box.querySelector('.rog-unit');
    if (!s) { s = document.createElement('span'); s.className = 'rog-unit'; s.setAttribute('aria-hidden', 'true'); box.appendChild(s); box.classList.add('rog-has-unit'); }
    if (s.textContent !== short(unit)) s.textContent = short(unit);
    /* pin the unit to the input's own right edge (in Safari the input can be narrower than its box) */
    var ip = box.querySelector('input');
    if (ip && ip.offsetWidth) {
      var rgt = Math.max(0, box.clientWidth - (ip.offsetLeft + ip.offsetWidth)) + 10 + 'px';
      if (s.style.right !== rgt) s.style.right = rgt;
    }
    /* only show the unit once a number is typed, so it doesn't sit on top of the label */
    var inp = box.querySelector('input'), empty = !inp || inp.value === '';
    if (box.classList.contains('rog-empty') !== empty) box.classList.toggle('rog-empty', empty);
    var lab = box.querySelector('.floating-label');
    if (lab) {
      var base = lab.dataset.rogBase || (lab.dataset.rogBase = lab.textContent.trim());
      var want = base + ' (' + unitLabel(unit) + ')';
      if (lab.textContent !== want) lab.textContent = want;
    }
  }
  function readout(host, after, html) {
    var r = host.querySelector(':scope > .rog-readout');
    if (!html) { if (r) r.remove(); return; }
    if (!r) { r = document.createElement('p'); r.className = 'rog-readout'; r.setAttribute('aria-live', 'polite'); }
    if (after && after.nextSibling !== r) after.parentNode.insertBefore(r, after.nextSibling);
    if (r.innerHTML !== html) r.innerHTML = html;
  }
  function unitSwitch(tile, unit) {
    var sw = tile.querySelector('.rog-unit-switch');
    if (!sw) {
      sw = document.createElement('div');
      sw.className = 'rog-unit-switch'; sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Unit of measurement');
      sw.innerHTML = '<button type="button" data-u="mm">mm</button><button type="button" data-u="cm">cm</button><button type="button" data-u="inch">inch</button>';
      sw.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[data-u]'); if (!b) return;
        e.preventDefault();
        choosePanelsUnit(b.getAttribute('data-u'));
        setTimeout(function () { unitsTick(); document.querySelectorAll('.tiles-customiser .tile').forEach(checkTile); }, 80);
      });
      var h = tile.querySelector('.input-styled.height');
      if (h) h.parentNode.insertBefore(sw, h.nextSibling); else tile.appendChild(sw);
    }
    sw.querySelectorAll('button').forEach(function (b) {
      var on = b.getAttribute('data-u') === unit;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
    });
  }
  function unitsTick() {
    /* Panels & splashbacks */
    var tiles = document.querySelectorAll('.tiles-customiser .tile');
    if (tiles.length) {
      var u = panelsUnit();
      var area = document.querySelector('.tiles-customiser .unit-area');
      if (area && !area.classList.contains('rog-unit-moved')) area.classList.add('rog-unit-moved');
      tiles.forEach(function (tile) {
        var wB = tile.querySelector('.input-styled.width'), hB = tile.querySelector('.input-styled.height');
        if (!wB || !hB) return;
        suffix(wB, u); suffix(hB, u); unitSwitch(tile, u);
        var w = parseFloat(wB.querySelector('input').value), h = parseFloat(hB.querySelector('input').value);
        readout(tile, tile.querySelector('.rog-unit-switch') || hB, readoutText(w, h, u, 'Each panel: '));
      });
    }
    /* Framed mirrors */
    var fw = document.getElementById('width'), fh = document.getElementById('height');
    if (fw && fh && document.getElementById('unit')) {
      var fu = framedUnit();
      suffix(fw, fu); suffix(fh, fu);
      var w2 = parseFloat(fw.querySelector('input').value), h2 = parseFloat(fh.querySelector('input').value);
      readout(fh.parentNode, fh, readoutText(w2, h2, fu, 'Your mirror: '));
    }
  }
  function initUnits() {
    var pending = false;
    var run = function () { if (pending) return; pending = true; setTimeout(function () { pending = false; try { unitsTick(); } catch (e) {} }, 120); };
    document.addEventListener('input', run, true);
    document.addEventListener('change', run, true);
    document.addEventListener('click', run, true);
    try { new MutationObserver(run).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('resize', run);
    run();
  }

  /* ---------- Framed mirror calculator: Capsule / office layout (12 Oct 2026) ----------
     The review step, the basket and the invoice show the framed mirror in the same order
     as the draft order (Shopify Flow) and Capsule: ITEM, FINISH, GLASS, EDGES, SIZE,
     HANGING or ORIENTATION, LAYOUT, PANEL SIZES, FRAME MOULDING, FRAME FINISH, STUDS,
     MOUNTING, FIXINGS, DELIVERY, LEAD TIME. Inspira's own list is kept (hidden) as the source. */
  function framedSource() {
    var box = document.querySelector('.frames-bespoke .product-info');
    if (!box) return null;
    var o = {};
    box.querySelectorAll('p').forEach(function (p) {
      var t = p.textContent.replace(/\s+/g, ' ').trim(), i = t.indexOf(':');
      if (i > 0) o[t.slice(0, i).trim()] = t.slice(i + 1).trim();
    });
    /* before a size is entered Inspira shows 0x0mm and "none" */
    return /^[1-9]\d*(\.\d+)?\s*x\s*[1-9]/.test(o['External Mirror Size'] || '') ? o : null;
  }
  function framedCapsule(o) {
    var frm = o['Frame Finish & Profile'] || '';
    var frameless = /frameless/i.test(frm);
    var finish = (o['Mirror Finish'] || '').replace(/\s*Finish\s*$/i, '').trim();
    var f = finish.toLowerCase();
    var base = /fluted/.test(f) ? 'Fluted' : /on bronze/.test(f) ? 'Bronze Tinted' : /on grey/.test(f) ? 'Grey Tinted' : '';
    var size = (o['External Mirror Size'] || '').replace(/mm/i, '').split('x').map(function (x) { return x.trim(); });
    var hang = o['Hanging'] || '';
    var lay = o['Layout'] || '';
    var layout = /single panel/i.test(lay) ? 'Single Panel'
      : (lay.split(' - ').pop() || lay).replace(/\s+columns?\s+and\s+/i, ' columns x ').replace(/\s+rows?$/i, ' rows');
    var stud = o['Decorative Studs'] || '';
    var parts = frm.split(' & ');
    var out = [
      ['ITEM', frameless ? 'Frameless Antiqued Mirror' : 'Framed Antiqued Mirror'],
      ['FINISH', finish],
      ['GLASS', base ? '4mm ' + base + ' Float' : '4mm Plain Float'],
      ['EDGES', (o['Edges'] || '').trim() || 'PAR (Polished All Round)']
    ];
    var sz = size.length === 2 ? '1 @ ' + size[0] + ' x ' + size[1] + 'mm' : o['External Mirror Size'];
    if (frameless) {
      out.push(['EXTERNAL MIRROR SIZE', sz]);
      out.push(['ORIENTATION', hang.split(' & ')[0].trim()]);
    } else {
      out.push(['EXTERNAL MIRROR SIZE (Including the Frame)', sz]);
      out.push(['HANGING', hang.replace(/ & /g, ' / ')]);
    }
    out.push(['LAYOUT', layout]);
    if (frameless) {
      out.push(['PANEL SIZES', 'We will send a drawing to be approved prior to production']);
    } else {
      out.push(['PANEL SIZES', 'Drawing to be approved prior to production']);
      out.push(['FRAME MOULDING', (parts[1] || '').trim()]);
      out.push(['FRAME FINISH', (parts[0] || '').trim()]);
    }
    out.push(['DECORATIVE STUDS', !stud || /^none$/i.test(stud) ? 'None' : stud]);
    if (frameless) out.push(['MOUNTING', 'Mounted onto a painted MDF backboard without frame']);
    out.push(['FIXINGS', /yes/i.test(o['Fixings'] || '') ? 'Including metal split batten fixings, suitable for flat walls' : 'Not included']);
    out.push(['DELIVERY', 'UK Mainland Weekday Included']);
    out.push(['ANTICIPATED LEAD TIME', '4-6 weeks for production & delivery']);
    return out;
  }
  function framedSpecTick() {
    var src = document.querySelector('.frames-bespoke .product-info');
    if (!src) return;
    var o = framedSource();
    var mine = src.parentNode.querySelector('.rog-framed-spec');
    if (!o) { if (mine) mine.hidden = true; src.style.display = ''; return; }
    if (!mine) { mine = document.createElement('div'); mine.className = 'rog-framed-spec'; src.parentNode.insertBefore(mine, src.nextSibling); }
    var html = framedCapsule(o).map(function (r) {
      return '<p class="attr"><span>' + escH(r[0]) + ':</span> ' + escH(r[1]) + '</p>';
    }).join('');
    mine.hidden = false;
    if (mine.dataset.html !== html) { mine.innerHTML = html; mine.dataset.html = html; }
    src.style.display = 'none';
  }
  function escH(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Basket and invoice: the same lines go onto the basket item as line item properties */
  function initFramedSpec() {
    if (!/\/pages\/customise/.test(location.pathname)) return;
    var pending = false;
    var run = function () { if (pending) return; pending = true; setTimeout(function () { pending = false; try { framedSpecTick(); } catch (e) {} }, 150); };
    try { new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    run();
    var hook = function () {
      var $ = window.jQuery;
      if (!$ || !$.ajaxPrefilter) return false;
      $.ajaxPrefilter(function (opts) {
        if (!opts.url || opts.url.indexOf('/cart/add') < 0) return;
        var o = framedSource(); if (!o) return;
        var add = framedCapsule(o).map(function (r) { return encodeURIComponent('properties[' + r[0] + ']') + '=' + encodeURIComponent(r[1]); }).join('&');
        if (typeof opts.data === 'string') { if (opts.data.indexOf('properties%5BITEM%5D') < 0) opts.data += (opts.data ? '&' : '') + add; }
        else if (opts.data == null) opts.data = add;
      });
      return true;
    };
    if (!hook()) { var n = 0, iv = setInterval(function () { if (hook() || ++n > 40) clearInterval(iv); }, 250); }
  }

  /* ---------- Framed calculator: line drawings for the panel layouts (12 Oct 2026) ----------
     Replaces the layout photos with drawings (assets/rog-layout-*.svg). The frameless
     drawings (glass on a backboard) show when Frameless is chosen as the frame. */
  var LAYOUT_FILES = { 'single panel': 'single-panel', 'panelled': 'panelled', 'bordered design': 'bordered-design',
    'bordered mitred design': 'bordered-mitred-design', 'mondrian geometric design': 'mondrian-geometric-design' };
  function assetBase() {
    var s = document.querySelector('script[src*="estimator-checks.js"]');
    return s ? s.src.split('?')[0].replace(/estimator-checks\.js$/, '') : null;
  }
  function layoutDrawings() {
    var els = document.querySelectorAll('#layout .frame-element');
    if (!els.length) return;
    var base = assetBase(); if (!base) return;
    var fl = selectedFrameless();
    els.forEach(function (el) {
      var t = el.querySelector('.title'), im = el.querySelector('.image');
      var f = t && LAYOUT_FILES[t.textContent.trim().toLowerCase()];
      if (!f || !im) return;
      var url = base + 'rog-layout-' + f + (fl ? '-frameless' : '') + '.svg?v=35'; /* bump v when a drawing changes (the CDN caches by URL) */
      if (im.dataset.rogDrawing === url) return;
      im.dataset.rogDrawing = url;
      im.setAttribute('data-bksrc', url);
      im.style.backgroundImage = 'url("' + url + '")';
      im.classList.add('rog-drawn');
      /* also as a real image on top, so nothing (or any browser) can swap the photo back in */
      var pic = im.querySelector('img.rog-layout-img');
      if (!pic) { pic = document.createElement('img'); pic.className = 'rog-layout-img'; pic.alt = ''; im.appendChild(pic); }
      if (pic.getAttribute('src') !== url) pic.setAttribute('src', url);
    });
  }
  function initLayoutDrawings() {
    if (!/\/pages\/customise/.test(location.pathname)) return;
    var pending = false;
    var run = function () { if (pending) return; pending = true; setTimeout(function () { pending = false; try { layoutDrawings(); } catch (e) {} }, 150); };
    document.addEventListener('click', run, true);
    try { new MutationObserver(run).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] }); } catch (e) {}
    run();
  }

  /* ---------- Framed calculator: pick Portrait or Landscape from the size (12 Oct 2026) ----------
     Taller than wide = Portrait, wider than tall = Landscape. Only until the customer picks an
     orientation themselves, and never over "Ability to Hang Either Way". */
  var orientManual = false;
  function autoOrient() {
    var wB = document.getElementById('width'), hB = document.getElementById('height');
    if (!wB || !hB || orientManual) return;
    var w = parseFloat(wB.querySelector('input').value), h = parseFloat(hB.querySelector('input').value);
    if (!(w > 0) || !(h > 0) || w === h) return;
    if (document.querySelector('#orientation .orientation.both.selected')) return;
    var el = document.querySelector('#orientation .orientation.' + (h > w ? 'portrait' : 'landscape'));
    if (el && !el.classList.contains('selected')) { el.dataset.rogAuto = '1'; el.click(); }
  }
  function initAutoOrient() {
    if (!/\/pages\/customise/.test(location.pathname)) return;
    document.addEventListener('click', function (e) {
      var o = e.target && e.target.closest && e.target.closest('#orientation .orientation');
      if (!o) return;
      if (o.dataset.rogAuto) { delete o.dataset.rogAuto; return; }
      if (e.isTrusted) orientManual = true;
    }, true);
    var t = null;
    var run = function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('#width, #height')) return;
      clearTimeout(t); t = setTimeout(autoOrient, 400);
    };
    document.addEventListener('input', run, true);
    document.addEventListener('change', run, true);
  }

  /* ---------- Panels calculator: shapes with drawings, and the right drawing options (12 Oct 2026) ----------
     Shapes are set in sections/bespoke-tiles-size-and-shape.liquid. Drawing rules (Charlotte):
     - Square or Rectangle, Circle, (true) Oval, (true) Arched Top: no drawing, unless there are cut-outs or holes
     - Inverted T, Raked, Scribed and Free Shape: a sketch, DXF drawing or template */
  var SHAPES = [
    ['Square or Rectangle', 'square-or-rectangle', 'geo', 'Right-angled corners, straight edges'],
    ['Circle', 'circle', 'geo', 'Round panel'],
    ['Oval', 'oval', 'geo', 'A true (geometric) oval'],
    ['Arched Top', 'arched-top', 'geo', 'Rectangular with a curved top'],
    ['Inverted T Shape', 'inverted-t', 'sketch', 'Taller in the middle, e.g. a splashback rising behind a hob'],
    ['Raked', 'raked', 'sketch', 'Straight edges, out of square, e.g. under a sloping ceiling or where walls or surfaces are not level'],
    ['Scribed', 'scribed', 'template', 'Rectangular, with one or more edges scribed to follow an uneven wall'],
    ['Free Shape', 'free-shape', 'template', 'Curved edges, any outline']
  ];
  var SHAPE_NOTES = {
    'Oval': 'Oval means a true (geometric) oval. If yours isn’t a true oval, please choose Free Shape.',
    'Arched Top': 'Arched Top means a true arch. For any other curve, please choose Free Shape.',
    'Scribed': 'We usually recommend panels are cut point to point rather than scribed, but we can scribe them to the wall if you’d prefer.'
  };
  var DRAW_ORIG = ['No Drawings or Templates Required', 'I will provide a sketched drawing', 'I will provide a DXF (CAD) drawing', 'I will provide an MDF or Ply Template'];
  var cutAns = null;
  function shapeBy(title) {
    title = String(title || '').trim();
    for (var i = 0; i < SHAPES.length; i++) if (SHAPES[i][0] === title) return SHAPES[i];
    return null;
  }
  function shapeUrl(slug) { var b = assetBase(); return b ? b + 'rog-shape-' + slug + '.svg?v=1' : ''; }
  function chosenShapes(s) {
    return (s.tilesDimensions || []).map(function (t) { return t && t.shape && t.shape.option; }).filter(Boolean);
  }
  function drawMode(s) {
    var cats = chosenShapes(s).map(function (o) { var x = shapeBy(o); return x ? x[2] : 'geo'; });
    if (!cats.length) return null;
    if (cats.indexOf('template') > -1) return 'template';
    if (cats.indexOf('sketch') > -1) return 'sketch';
    return 'geo';
  }
  function listNames(arr) { return arr.length > 1 ? arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1] : arr[0]; }
  function namesOf(s, cat) {
    var out = [];
    chosenShapes(s).forEach(function (o) { var x = shapeBy(o); if (x && x[2] === cat && out.indexOf(x[0]) < 0) out.push(x[0].replace(' Shape', '').toLowerCase().replace('inverted t', 'inverted T')); });
    return out;
  }
  function drawRule(s) {
    var mode = drawMode(s);
    var idx = DRAW_ORIG.indexOf(s.drawingOption || '');
    if (mode === 'geo' && cutAns === null && idx > -1) cutAns = idx === 0 ? 'no' : 'yes';
    var allowed = mode === 'template' || mode === 'sketch' ? [1, 2, 3] : mode === 'geo' ? (cutAns === 'no' ? [0] : cutAns === 'yes' ? [1, 2, 3] : []) : [0, 1, 2, 3];
    var msg = '';
    if (mode === 'template' || mode === 'sketch') msg = '<strong>' + listNames(namesOf(s, 'sketch').concat(namesOf(s, 'template'))).replace(/^./, function (c) { return c.toUpperCase(); }) + ' panels need a sketch, DXF drawing or template</strong> so we can cut them accurately.';
    else if (mode === 'geo' && cutAns === 'yes') msg = '<strong>Panels with cut-outs or holes need a sketch, DXF drawing or template.</strong> A sketch is the most cost-effective option.';
    else if (mode === 'geo' && cutAns === 'no') msg = '<strong>No drawing needed.</strong> We can cut these panels from the sizes you enter.';
    var ok = mode === null || allowed.indexOf(idx) > -1;
    return { mode: mode, idx: idx, allowed: allowed, msg: msg, ok: ok };
  }
  function shapeUX() {
    var app = document.querySelector('.tiles-customiser');
    if (!app) return;
    var s = panelsState(); if (!s) return;
    /* drawings and descriptions in the shape lists, and a picture of each panel's chosen shape */
    var tiles = app.querySelectorAll('.tile');
    tiles.forEach(function (tile, i) {
      var dd = null;
      tile.querySelectorAll('.step--dropdown').forEach(function (d) { var l = d.querySelector('.label'); if (l && /shape/i.test(l.textContent)) dd = d; });
      if (!dd) return;
      dd.classList.add('rog-shape-dd');
      dd.querySelectorAll('li').forEach(function (li) {
        if (li.dataset.rogShape) return;
        var x = shapeBy(li.textContent); if (!x) return;
        li.dataset.rogShape = x[1];
        var im = document.createElement('img'); im.className = 'rog-shape-ico'; im.alt = ''; im.src = shapeUrl(x[1]);
        li.insertBefore(im, li.firstChild);
        var d = document.createElement('span'); d.className = 'rog-shape-desc'; d.textContent = x[3]; li.appendChild(d);
      });
      var t = (s.tilesDimensions || [])[i], x = t && t.shape && shapeBy(t.shape.option);
      var pic = tile.querySelector('.rog-shape-pic');
      if (!x) { if (pic) pic.hidden = true; return; }
      if (!pic) { pic = document.createElement('div'); pic.className = 'rog-shape-pic'; pic.innerHTML = '<img alt=""><p></p>'; dd.parentNode.insertBefore(pic, dd.nextSibling); }
      pic.hidden = false;
      var img = pic.querySelector('img'), u = shapeUrl(x[1]);
      if (img.getAttribute('src') !== u) img.setAttribute('src', u);
      var note = SHAPE_NOTES[x[0]] || '', p = pic.querySelector('p');
      if (p.textContent !== note) p.textContent = note;
      p.hidden = !note;
    });
    /* the drawing question: only the options that suit the shapes chosen */
    var box = app.querySelector('.grid.drawings');
    var dd2 = app.querySelector('.drawings--dropdown');
    if (!box || !dd2) return;
    var r = drawRule(s);
    var q = document.getElementById('rog-cutq');
    if (!q || !box.contains(q)) {
      if (q) q.remove();
      q = document.createElement('div'); q.id = 'rog-cutq'; q.className = 'rog-cutq';
      q.innerHTML = '<p><strong>Will any of these panels need cut-outs or holes?</strong> For example for sockets, switches, pipes or taps, or to fit around cabinetry.</p>' +
        '<div class="rog-note-actions"><button type="button" class="rog-btn rog-btn-quiet" data-a="yes">Yes</button><button type="button" class="rog-btn rog-btn-quiet" data-a="no">No</button></div>';
      q.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[data-a]'); if (!b) return;
        e.preventDefault();
        cutAns = b.getAttribute('data-a');
        var items = drawingItems(), st = panelsState();
        var cur = st ? DRAW_ORIG.indexOf(st.drawingOption || '') : -1;
        if (cutAns === 'no' && cur !== 0 && items[0]) items[0].click();
        setTimeout(shapeUX, 60);
      });
      box.insertBefore(q, dd2);
    }
    q.hidden = r.mode !== 'geo';
    q.querySelectorAll('button').forEach(function (b) { var on = b.getAttribute('data-a') === cutAns; b.classList.toggle('rog-btn-quiet', !on); b.setAttribute('aria-pressed', String(on)); });
    var hideDD = r.mode === 'geo' && cutAns !== 'yes';
    dd2.classList.toggle('rog-dd-hidden', hideDD);
    if (r.mode === 'geo' && cutAns === 'no' && r.idx !== 0 && drawingItems()[0]) drawingItems()[0].click();
    drawingItems().forEach(function (li, i) { li.classList.toggle('rog-opt-off', r.allowed.indexOf(i) < 0); });
    var rn = document.getElementById('rog-draw-rule');
    if (!rn || !box.contains(rn)) { if (rn) rn.remove(); rn = makeNote('rog-note-info'); rn.id = 'rog-draw-rule'; box.insertBefore(rn, dd2.nextSibling); }
    rn.hidden = !r.msg;
    var rhtml = '<p>' + r.msg + (r.ok || r.mode === 'geo' && cutAns !== 'yes' ? '' : ' Please choose one below.') + '</p>';
    if (rn.dataset.msg !== rhtml) { rn.dataset.msg = rhtml; rn.innerHTML = rhtml; }
  }
  function initShapes() {
    var pending = false;
    var run = function () { if (pending) return; pending = true; setTimeout(function () { pending = false; try { shapeUX(); } catch (e) {} }, 120); };
    try { new MutationObserver(run).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    document.addEventListener('click', function () { setTimeout(run, 80); }, true);
    run();
    /* don't leave the size step until the drawing choice suits the shapes */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.total-submit .next, .step--navigation .right')) return;
      var cont = document.querySelector('.tiles-customiser .right-column .step--container.size--and--shape');
      var s = panelsState();
      if (!cont || !s) return;
      var r = drawRule(s);
      if (r.ok && !(r.mode === 'geo' && cutAns === null)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      shapeUX();
      var target = r.mode === 'geo' && cutAns === null ? document.getElementById('rog-cutq') : document.getElementById('rog-draw-rule');
      if (target) {
        if (target.id === 'rog-draw-rule' && target.hidden) { target.hidden = false; }
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        target.classList.add('rog-note-flash');
        setTimeout(function () { target.classList.remove('rog-note-flash'); }, 1600);
      }
    }, true);
  }

  function start() {
    initLabel();
    /* Both listeners only act on their own calculator's elements, and the panels
       app (Vue) replaces its mount point, so don't gate on what exists at load. */
    if (document.querySelector('.frames-bespoke')) initFramed();
    initPanels();
    initPanelsUX();
    initUnits();
    initFramedSpec();
    initLayoutDrawings();
    initAutoOrient();
    initShapes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
